import { useNavigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { Breadcrumb } from "../components/Topbar";
import { PageHeader } from "../components/PageHeader";
import { DataTable, type Column } from "../components/DataTable";
import { Badge } from "../components/Badge";
import { useTenants, type TenantSummary } from "../hooks/useTenants";
import { formatDate } from "../lib/format";
import { colors, fontSize, fontWeight, radius } from "../lib/tokens";

const STATE_PALETTES: Record<string, string> = {
  "thelatvian": "#1A2A52",
  "the-latvian": "#1A2A52",
  "forgepub": "#0F4D3A",
};

export function TenantsPage() {
  const navigate = useNavigate();
  const { tenants, loading } = useTenants();

  const columns: Column<TenantSummary>[] = [
    {
      key: "tenant",
      header: "Tenant",
      render: (r) => {
        const bg = STATE_PALETTES[r.slug] ?? colors.graphite;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 36, height: 36, borderRadius: radius.sm, background: bg, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: fontWeight.medium, fontSize: fontSize.base }}>
              {r.name[0]}
            </div>
            <div>
              <div style={{ fontWeight: fontWeight.medium }}>{r.name}</div>
              <div style={{ fontFamily: "JetBrains Mono", fontSize: 11, color: colors.stone, marginTop: 2 }}>{r.slug}</div>
            </div>
          </div>
        );
      },
    },
    { key: "state", header: "Estado", render: (r) => <Badge state={r.lifecycle_state} /> },
    { key: "created", header: "Cliente desde", render: (r) => <span style={{ color: colors.stone }}>{formatDate(r.created_at)}</span> },
  ];

  return (
    <Layout breadcrumbs={<Breadcrumb items={[{ label: "Tenants" }]} />}>
      <PageHeader
        title="Tenants"
        subtitle={`${tenants.length} organizações na plataforma`}
      />
      <DataTable
        columns={columns}
        rows={tenants}
        loading={loading}
        onRowClick={(t) => navigate(`/tenants/${t.slug}`)}
        empty="Nenhum tenant ainda."
      />
    </Layout>
  );
}
